var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-form__inline"},[_c('content-editable',{class:_vm.getInvalidClass('targetValue'),attrs:{"value":_vm.dataNew.targetValue},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }